import React from 'react';

export default function ArrowUp({
  width = '22',
  height = '42',
  stroke = 'rgba(28,61,90,1)',
  transform,
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={transform}
      style={{
        transition: 'transform 0.2s ease-in',
      }}
    >
      <path d="M1 41L21 21L1 0.999998" stroke={stroke} strokeWidth="2.5" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ../shop_main/images/arrowRight.js